import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { StockService } from 'modules/inventory/warehouse/services';
import { PRODUCTS_WAREHOUSE_STOCK } from '../constants/query-keys';
import { PRODUCTS_ONE_KEY } from 'modules/inventory/product/constants';

const useProductStockUpdateWarehouseArea = (productId: string, warehouseId: string) => {
  const { t } = useTranslation(['product', 'errors']);
  const queryClient = useQueryClient();

  const { mutateAsync, isPending: isLoading } = useMutation(
    (warehouseArea: string | null) => StockService.updateWarehouseArea(productId, warehouseId, warehouseArea),
    {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: [PRODUCTS_WAREHOUSE_STOCK] });
        queryClient.invalidateQueries({ queryKey: [productId, PRODUCTS_ONE_KEY] });
        toast.success(t('product:updateWarehouseAreaSuccess'));
      },
      onError: () => {
        toast.error(t('generalErrorMessage', { ns: 'errors' }));
      },
    },
  );

  return {
    updateWarehouseArea: mutateAsync,
    isLoading,
  };
};

export default useProductStockUpdateWarehouseArea;
